const landingSlider = () => {

    const container = '.js-landing-container';
    const blocks = document.querySelectorAll('.js-landing-animation-item');
    let width = $(window).width();
    TweenLite.defaultEase = Linear.easeNone;

    const controller = new ScrollMagic.Controller();

    function initAnimation() {
        const infoBlockAnim = new TimelineMax();
        const horizontalSlide = new TimelineMax()
            .to(`.js-landing-animation-item .img-0`, {
                y: '0',
                ease: "Power2.easeOut",
                duration: 4,
                stagger: 0.3,
            }, "point")
            .to(`.js-landing-animation-item .item-title-first`, {
                opacity: 0,
                ease: "Power2.easeInOut",
                duration: 2,
                stagger: 0.3,
            }, "point")
            .to(`.js-landing-animation-item .item-title-first`, {
                position: 'absolute',
                delay: 2,
            }, "point")
            .to(['.js-landing-animation-item .item-title-0', '.js-landing-animation-item .item-description-0'], {
                position: 'relative',
                opacity: 2,
                ease: "Power2.easeInOut",
                duration: 2,
                delay: 2,
                stagger: 0.3,
            }, "point")
            .from(blocks[1], 2, {opacity: 0, zIndex: 2}, "label2")
            .to(`.js-landing-animation-item .img-1`, {
                y: '0',
                ease: "Power2.easeOut",
                duration: 4,
                stagger: 0.3,
            })
            .to([`.js-landing-animation-item .item-title-0`, '.js-landing-animation-item .item-description-0'], {
                opacity: 0,
                ease: "Power2.easeInOut",
                duration: 2,
                stagger: 0.3,
            }, "label2")
            .to([`.js-landing-animation-item .item-title-0`, '.js-landing-animation-item .item-description-0'], {
                position: 'absolute',
                delay: 2,
            }, "label2")
            .to(['.js-landing-animation-item .item-title-1', '.js-landing-animation-item .item-description-1'], {
                position: 'relative',
                opacity: 2,
                ease: "Power2.easeInOut",
                duration: 2,
                delay: 2,
                stagger: 0.3,
            }, "label2")
            .from(blocks[2], 2, {
                opacity: 0,
                onComplete: function () {
                    let promoImage = $('.js-promo-image'),
                        promoBg = $('.js-promo-bg'),
                        promoParent = promoBg.parents('.js-landing-animation-item');

                    promoBg.css({
                        'top': promoImage.offset().top - promoParent.offset().top,
                        'left': promoImage.offset().left,
                        'width': promoImage.outerWidth(),
                        'height': promoImage.outerHeight(),
                    })
                },
                zIndex: 2
            }, "label3")
            .to(`.js-landing-animation-item .img-2`, {
                y: '0',
                ease: "Power2.easeOut",
                duration: 4,
                stagger: 0.3,
            }, 'label3')
            .to([`.js-landing-animation-item .item-title-1`, `.js-landing-animation-item .item-description-1`], {
                opacity: 0,
                ease: "Power2.easeInOut",
                duration: 2,
                stagger: 0.3,
            }, "label3")
            .to([`.js-landing-animation-item .item-title-1`, `.js-landing-animation-item .item-description-1`], {
                position: 'absolute',
                delay: 2,
            }, "label3")
            .to(['.js-landing-animation-item .item-title-2', '.js-landing-animation-item .item-description-2'], {
                opacity: 1,
                position: 'relative',
                ease: "Power2.easeInOut",
                duration: 2,
                delay: 2,
                stagger: 0.3,
            }, "label3")
            .to(`.js-landing-animation-item .landing-promo__bg`, 0.2, {
                opacity: 1,
            }, ">")
            .to(`.js-landing-animation-item .landing-promo__bg`, 5, {
                top: 0,
                left: 0,
                opacity: 1,
                width: '100vw',
                height: '100vh',
                borderRadius: 0,
                ease: SlowMo.ease.config(0.3, 0.2), //Linear.easeNone
                onComplete: function () {
                    if (!$('.landing-info__inner').hasClass('visible')) {
                        infoBlockAnim.to(window, {
                            scrollTo: "#landing-info__inner",
                            duration: 1,
                            onComplete: function () {
                                $('.landing-info__inner').addClass('visible')
                            }
                        })
                    }
                }
            }, ">")
        ;

        // create scene to pin and link animation
        return new ScrollMagic.Scene({
            triggerElement: container,
            triggerHook: 0,
            duration: "450%",
        })
            .setPin(container)
            .setTween(horizontalSlide)
            .addTo(controller);
    }

   initAnimation();

    $(window).on('resize', function () {
        if (width !== $(window).width()) {
            location.reload();
        }
    });

}

export default landingSlider;
